import "./ExpenseCategoryTabUI.css";

import { FC, useEffect, useMemo, useState } from "react";

import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { ExpenseCategoryService } from "../../../../../services/ExpenseCategoryService";
import { ExpenseCategoryTabToolbar } from "./ExpenseCategoryTabToolbar/ExpenseCategoryTabToolbar";
import { IAppState } from "../../../../../store/reducers";
import { InputText } from "primereact/inputtext";
import { expenseCategoryInitialData } from "../../../EmployeeAssignemnt";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { useTheme } from "@mui/material";
import { EnhancedButtonPrimeReact, EnhancedButtonPrimeReactSeverity } from "@websential/cosmic-v20";
import { sortDDLByLabel } from "../../../../../common/Common";

let emptyExpenseCat = {
	id: null,
	expenseCategory: "",
	fromDate: null,
	toDate: null,
	notes: "",
	rowWithRandomId: true
};

const useGetExpenseCategoryDDL = (clientId: string) =>
	useQuery({
		queryKey: ["expense-category-ddl", clientId],
		queryFn: () => {
			return ExpenseCategoryService.getGetExpenseCategoryDDL(clientId);
		},
		refetchOnWindowFocus: false,
	});

interface IExpenseCategoryTabsPanel {
	expenseCategoryUpdatedData: (data: any) => void;
	expenseCategoryDataItems: any;
	TabTableheaderColumns: any;
	selectedEmployeeLabel: string;
	onRowDeleteClicked: (data: any) => void;
}
export const ExpenseCategoryTabsPanel: FC<IExpenseCategoryTabsPanel> = ({
	expenseCategoryUpdatedData,
	expenseCategoryDataItems,
	TabTableheaderColumns,
	selectedEmployeeLabel,
	onRowDeleteClicked,
}) => {
	const theme = useTheme();
	const [expenseCategory, setExpenseCategory] = useState<any>(
		expenseCategoryDataItems
	);
	const [selectedExpenseCategory, setSelectedExpenseCategory] =
		useState<any>(null);
	const [expenseCat, setExpenseCat] = useState(emptyExpenseCat);
	const [lastAddedRowId, setLastAddedRowId] = useState<any>(null);

	const clientId = useSelector((state: IAppState) => state.client.id);

	const { data: expenseCategoryDDL, isLoading: isLoading } =
		useGetExpenseCategoryDDL(clientId);
	const expenseCategoryDDLItems = useMemo(() => {
		if (expenseCategoryDDL && Array.isArray(expenseCategoryDDL)) {
			let resources: any[] = sortDDLByLabel(expenseCategoryDDL).map((resourceItem: any) => ({
				id: resourceItem.id,
				label: resourceItem.label,
				value: resourceItem.value,
			}));
			resources.unshift({
				label: "--",
				value: null,
			});
			return resources;
		}
		return [
			{
				label: "--",
				value: null,
			},
		];
	}, [expenseCategoryDDL]);

	useEffect(() => {
		expenseCategoryUpdatedData(expenseCategory);
	}, [expenseCategory]);

	useEffect(() => {

		setExpenseCategory(expenseCategoryDataItems);
	}, [expenseCategoryDataItems]);
	const findIndexById = (id: string | number | any) => {
		let index = -1;

		for (let i = 0; i < expenseCategory.length; i++) {
			if (expenseCategory[i].id === id) {
				index = i;
				break;
			}
		}

		return index;
	};

	const createId = () => {
		let id = "";
		let chars =
			"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

		for (let i = 0; i < 5; i++) {
			id += chars.charAt(Math.floor(Math.random() * chars.length));
		}

		return id;
	};

	// const openNew = () => {
	// 	// alert("new")

	// 	let _expenseCategory = [...expenseCategory];
	// 	let _expenseCat: any = { ...expenseCat };

	// 	if (expenseCat.id) {
	// 		const index = findIndexById(expenseCat.id);

	// 		_expenseCategory[index] = _expenseCat;
	// 	} else {
	// 		_expenseCat.id = createId();
	// 		_expenseCategory.push(_expenseCat);
	// 	}



	// 	setExpenseCategory(_expenseCategory);
	// 	setExpenseCat(emptyExpenseCat);
	// };

	const openNew = () => {
		// if (employeeStatus && employeeStatus.length >= 4) return null;
		let _expenseCategorySetupPanelData = [...expenseCategory];
		let _expenseCatSetupPanelNewRow: any = { ...expenseCat };

		if (expenseCat.id) {
			const rowIndex = findIndexById(expenseCat.id);
			_expenseCategorySetupPanelData[rowIndex] = _expenseCatSetupPanelNewRow;

		} else {
			const newRowId = createId();
			_expenseCatSetupPanelNewRow.id = newRowId;
			_expenseCategorySetupPanelData.push(_expenseCatSetupPanelNewRow);
			setLastAddedRowId(newRowId && newRowId);

		}
		setExpenseCategory(_expenseCategorySetupPanelData);
		setExpenseCat(emptyExpenseCat);
	};

	const onCellValueChange = (event: any, rowIndex: number, field: any) => {
		// const updatedData = [...expenseCategory];
		// updatedData[rowIndex][event.field] = field;
		// setExpenseCategory(updatedData);
		setExpenseCategory((prev: any) => {
			const updatedData = [...prev];
			const updatedRow = { ...updatedData[rowIndex], [event.field]: field };
			updatedData[rowIndex] = updatedRow;
			return updatedData;
		});
	};

	const renderErrorClass = (field: any, rowIndex: number, rowData: any) => {
		if (field.field === "fromDate") {
			if (
				rowData.expenseCategory !== "" &&
				rowData.expenseCategory !== undefined &&
				rowData.expenseCategory !== null
			) {
				if (rowData.fromDate === null) {
					return "p-component p-filled calender-error-input";
				} else if (rowData.fromDate === "") {
					return "p-component p-filled calender-error-input";
				}
			}
		} else if (field.field === "expenseCategory") {
			if (
				rowData.fromDate !== "" &&
				rowData.fromDate !== undefined &&
				rowData.fromDate !== null
			) {
				if (rowData.expenseCategory === null) {
					return "p-component p-filled input-dropdown-fields .p-dropdown dropdown-error-input";
				} else if (rowData.expenseCategory === "") {
					return "p-component p-filled input-dropdown-fields .p-dropdown dropdown-error-input";
				}
			} else {
				return "p-component p-filled input-dropdown-fields .p-dropdown";
			}
		} else {
			return "p-component p-filled input-dropdown-fields";
		}
	};

	const columnsBody = (rowData: any, row: any, x: any) => {
		if (x.field === "label") {
			// <span style={{ color: "red" }}>*</span>
			return (
				<span>
					<b>
						Select Expense Category 
					</b>
				</span>
			);
		} else if (x.field === "expenseCategory") {
			return (
				<Dropdown
					options={expenseCategoryDDLItems}
					value={rowData.expenseCategory}
					onChange={(e: any) =>
						onCellValueChange(x, row.rowIndex, e.target.value)
					}
					placeholder="--"
					className={renderErrorClass(x, row.rowIndex, rowData)}
					optionLabel="label"
					optionValue="value"
				/>
			);
		} else if (x.field === "fromDate") {
			return (
				<Calendar
					id="fromDate"
					value={rowData[x.field]}
					showIcon
					// className="calender"
					style={{ height: "2.6rem", margin: "8px 0px 4px 0px", width: "auto" }}
					onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
					dateFormat="M dd, yy"
					placeholder={"dd/mm/yyyy"}
					className={`calender ${renderErrorClass(x, row.rowIndex, rowData)}`}
				/>
			);
		} else if (x.field === "toDate") {
			return (
				<Calendar
					id="toDate"
					value={rowData[x.field]}
					showIcon
					className="calender"
					style={{ height: "2.6rem", margin: "8px 0px 4px 0px", width: "auto" }}
					onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
					dateFormat="M dd, yy"
					placeholder={"dd/mm/yyyy"}
				/>
			);
		} else if (x.field === "notes") {
			return (
				<InputText
					value={rowData[x.field]}
					onChange={(e: any) =>
						onCellValueChange(x, row.rowIndex, e.target.value)
					}
					placeholder="Write notes here"
					className={"notesField p-component p-filled input-dropdown-fields"}
				/>
			);
		}
	};


	const onDeleteNewAddedRow = (rowId: any) => {
		setExpenseCategory((prev: any[]) => {
			const rowDeleteBasedOnId = prev.filter((row) => row.id !== rowId);

			if (rowDeleteBasedOnId.length > 1) {
				const lastRowId = rowDeleteBasedOnId[rowDeleteBasedOnId.length - 1].id;
				setLastAddedRowId(lastRowId);
			} else {
				setLastAddedRowId(null);
			}
			return rowDeleteBasedOnId;
		});
	}

	return (
		<>
			{expenseCategoryDDL ? (
				<div className="card">
					<ExpenseCategoryTabToolbar
						openNew={openNew}
						selectedEmployeeLabel={selectedEmployeeLabel}
					/>
					<DataTable
						value={expenseCategory}
						// key={JSON.stringify(expenseCategoryDDLItems)}
						dataKey="id"
						key={lastAddedRowId}
						showGridlines
						className="ExpenseCategoryTab"
						editMode="cell"
						resizableColumns
						columnResizeMode="expand"
						scrollable
						// reorderableColumns
						filterDisplay="menu"
						scrollHeight="516px"
						loading={isLoading}
					>
						{TabTableheaderColumns.map((x: any, index: any) => {
							return (
								<Column
									key={index}
									field={x.field}
									header={x.headerName}
									headerTooltip={x.description}
									headerTooltipOptions={{ position: "top" }}
									sortable={false}
									// resizeable={x.resizable}
									// dataType={x.type}
									align={x.align}
									alignHeader={x.headerAlign}
									reorderable={false}
									// exportable={x.disableExport}
									frozen={x.frozenColumn}
									columnKey={x.field}
									style={{
										width: x.minWidth,
										fontSize: "0.875rem",
									}}
									footer={x.footer}
									body={(rowData: any, row: any) =>
										columnsBody(rowData, row, x)
									}
								/>
							);
						})}

						{/* <Column
							body={(rowData: any, row: any) => {
								const showIcon = rowData.id === lastAddedRowId;
								return showIcon ? (
									<EnhancedButtonPrimeReact
										icon="pi pi-times"
										severity={EnhancedButtonPrimeReactSeverity.Danger}
										className="p-button-rounded p-button-text shadow-none bg-transparent"
										rounded
										// onClickHandler={onDeleteNewAddedRow}
										onClickHandler={() => onDeleteNewAddedRow(rowData.id)}
									/>
								) : null;
							}}
						/> */}


						<Column
							body={(rowData: any, row: any) => {
								const isLastRow = row.rowIndex === expenseCategory.length - 1;
								console.log("isLastRow", isLastRow)
								return isLastRow ? (
									<EnhancedButtonPrimeReact
										icon="pi pi-times"
										severity={EnhancedButtonPrimeReactSeverity.Danger}
										className="p-button-rounded p-button-text shadow-none bg-transparent  delete-row-btn"
										rounded
										onClickHandler={() => rowData.rowWithRandomId ? onDeleteNewAddedRow(rowData.id) : onRowDeleteClicked(rowData)}
									/>
								) : null;
							}}
						/>

					</DataTable>
				</div>
			) : (
				<></>
			)}
		</>
	);
};
